// Tests whether this is a mobile device
export const isMobileDevice = () => {
  const hasTouch = navigator.maxTouchPoints > 0;

  const ua = navigator.userAgent || navigator.vendor || (window as any).opera;
  const isMobileUa = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua);

  return hasTouch && isMobileUa;
};
